var ShippingObjectTypes = /* @__PURE__ */ ((ShippingObjectTypes2) => {
  ShippingObjectTypes2["BillingAddress"] = "billingAddress";
  ShippingObjectTypes2["DeliveryAddress"] = "deliveryAddress";
  ShippingObjectTypes2["ContactDetails"] = "contactDetails";
  ShippingObjectTypes2["Company"] = "company";
  ShippingObjectTypes2["Invoice"] = "invoice";
  ShippingObjectTypes2["ExpressCheckout"] = "expressCheckout";
  return ShippingObjectTypes2;
})(ShippingObjectTypes || {});
var CheckoutState = /* @__PURE__ */ ((CheckoutState2) => {
  CheckoutState2["Uninitialized"] = "uninitialized";
  CheckoutState2["Initialized"] = "initialized";
  CheckoutState2["Completed"] = "completed";
  CheckoutState2["Callback"] = "callback";
  CheckoutState2["Failed"] = "failed";
  return CheckoutState2;
})(CheckoutState || {});
const isState = (stateName) => (state) => state.root.state === stateName;
const isUninitialized = isState(
  "uninitialized"
  /* Uninitialized */
);
const isCompleted = isState(
  "completed"
  /* Completed */
);
const isFailed = isState(
  "failed"
  /* Failed */
);
export {
  CheckoutState,
  ShippingObjectTypes,
  isCompleted,
  isFailed,
  isUninitialized
};
//# sourceMappingURL=state.js.map
